import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// TODO: ld-tooltip will be replaced by ula-tooltip; this is a breaking change
import { TooltipModule } from '../tooltip';

import { UlaInputBaseComponent } from './ula-input-base.component';
import { UlaDateInputComponent } from './ula-date-input.component';
import { UlaSelectStateComponent } from './ula-select-state.component';
import { UlaSelectComponent } from './ula-select.component';
import { LDComponentsModule } from '../../ld-angular-components';
import { UlaEmailInputComponent } from './ula-email-input.component';
import { UlaInputGenericComponent } from './ula-input-generic.component';
import { UlaSsnInputComponent } from './ula-ssn-input.component';
import { FormValidationService } from './form-validation.service';
import { HomeStateValidatorDirective } from '../directives/state-validation.directive';
import { Utils } from './utils.service';
import { FormValidationErrorMessageModule } from '../validation/form-validation-error-message/form-validation-error-message.module';
import { MyDatePickerModule } from 'mydatepicker';
import { UlaRadioComponent } from './ula-radio.component';

@NgModule({
  declarations: [
    UlaDateInputComponent,
    UlaEmailInputComponent,
    UlaInputBaseComponent,
    UlaInputGenericComponent,
    UlaRadioComponent,
    UlaSelectComponent,
    UlaSelectStateComponent,
    UlaSsnInputComponent,
    HomeStateValidatorDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    LDComponentsModule,
    MyDatePickerModule,
    FormValidationErrorMessageModule,
    TooltipModule
  ],
  exports: [
    UlaDateInputComponent,
    UlaEmailInputComponent,
    UlaInputGenericComponent,
    UlaRadioComponent,
    UlaSelectComponent,
    UlaSelectStateComponent,
    UlaSsnInputComponent,
    HomeStateValidatorDirective
  ],
  providers: [
    FormValidationService,
    Utils
  ]
})
export class ForkCommonControlsModule { }
